import React, { useState } from 'react'
import { Modal, Form, Input, message } from 'antd'
import myDocumentStore from '../../stores/myDocumentStore'
import utils from '../../utils'

const CreateFolderModal = ({ visible, onCancel, onSuccess, parentId }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)
      await myDocumentStore.createDocument({
        name: values.name,
        type: 'folder',
        parentId: parentId || ''
      })
      message.success('Tạo thư mục thành công')
      form.resetFields()
      onSuccess()
    } catch (error) {
      if (!error.errorFields) {
        message.error('Lỗi khi tạo thư mục')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title="Tạo thư mục mới"
      visible={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      confirmLoading={loading}
      okText="Tạo mới"
      cancelText="Hủy"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Tên thư mục"
          rules={[{ required: true, message: 'Vui lòng nhập tên thư mục!' }]}
        >
          <Input placeholder="Nhập tên thư mục" autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateFolderModal
